module.exports = __webpack_public_path__ + "static/img/fgbg2-8.bbece87.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/2/fgbg2-8.png
// module id = 199
// module chunks = 0